import registrationModule from '../scripts/registration/registration.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(registrationModule);